<template>
  <div class="webform-progress clearfix">
    <ul class="webform-progress-tracker progress-tracker progress-tracker--center">
      <li data-webform-page="betekenisvol_werk" title="Betekenisvol werk" class="progress-step is-complete">
        <div class="progress-marker" @click="changeStep(1)">
          1
        </div>
      </li>
      <li data-webform-page="erkenning" title="Erkenning" class="progress-step is-active">
        <div class="progress-marker" @click="changeStep(2)">
          2
        </div>
      </li>
      <li data-webform-page="uitdaging" title="Uitdaging" class="progress-step">
        <div class="progress-marker" @click="changeStep(3)">
          3
        </div>
      </li>
      <li data-webform-page="leren" title="Leren" class="progress-step">
        <div class="progress-marker" @click="changeStep(4)">
          4
        </div>
      </li>
      <li data-webform-page="werk_kenmerken" title="Werk kenmerken" class="progress-step">
        <div class="progress-marker" @click="changeStep(5)">
          5
        </div>
      </li>
      <li data-webform-page="werk_hulpbronnen" title="Werk hulpbronnen" class="progress-step">
        <div class="progress-marker" @click="changeStep(6)">
          6
        </div>
      </li>
      <li data-webform-page="veerkracht" title="Veerkracht" class="progress-step">
        <div class="progress-marker" @click="changeStep(7)">
          7
        </div>
      </li>
      <li data-webform-page="omgaan_met_verandering" title="Omgaan met verandering" class="progress-step">
        <div class="progress-marker" @click="changeStep(8)">
          8
        </div>
      </li>
      <li data-webform-page="zelfleiderschap" title="Zelfleiderschap" class="progress-step">
        <div class="progress-marker" @click="changeStep(9)">
          9
        </div>
      </li>
      <li data-webform-page="ontspanning" title="Ontspanning" class="progress-step">
        <div class="progress-marker" @click="changeStep(10)">
          10
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
  export default {
    data: {
      active: 1
    },
    methods: {
      changeStep: function (step) {
        this.active = step;
      //  console.log('progess step: '+this.active)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Vitamins/Progress.vue